/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, May 30th 2022, 2:52:20 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useUserContext } from "authentication";
import { useAPIFetchUserDetails } from "users";

/**
 *
 * Hook to save logged in user details to localstorage in order to avoid always fetching user details from session.
 *
 */
export const useLocalSaveLoggedInUser = () => {
  const {
    isMakingAPIRequest: isFetchingUserDetails,
    fetchItem: fetchUserDetails,
    isSuccessfulAPIRequest: isSuccessfulUserDetailsFetch,
    apiItem: fetchedUserDetails,
    ...remainingValues
  } = useAPIFetchUserDetails();

  // Storing the LoggedInUser
  const { saveLoggedInUser, loggedInUser } = useUserContext();

  React.useEffect(() => {
    isSuccessfulUserDetailsFetch && saveLoggedInUser(fetchedUserDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedUserDetails?.id]);

  return { fetchUserDetails, isFetchingUserDetails, isSuccessfulUserDetailsFetch, loggedInUser, ...remainingValues };
};
